import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentContent, Handset } from 'src/app/domains/equipment/models';
import { EquipmentService } from 'src/app/domains/equipment/services';
import { User } from 'src/app/domains/sales/trial/models/trial.model';
import { UsersService } from 'src/app/domains/users/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-assign-to-user-popup',
  templateUrl: './assign-to-user-popup.component.html',
  styleUrls: ['./assign-to-user-popup.component.scss']
})
export class AssignToUserPopupComponent implements OnInit {
  public equipment: EquipmentContent;
  public handset: Handset;
  public users: User;
  public selectedUser;
  public loading: boolean = false;
  public loadingAssign: boolean = false;
  @Output() onAssignToUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAssignHandsetToUser: EventEmitter<any> = new EventEmitter<any>();
  @Output() onLoadingAssign: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private activeModal: NgbActiveModal,
    private usersService: UsersService,
    private equipmentService: EquipmentService,
    private notification: NotificationService,
    private translate: TranslateService
    ) { }

  ngOnInit() {
    this.loading = true;
    this.usersService.getUsers(this.equipment.pbx.company_id).subscribe((res: any) => {
      this.users = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.close();
    });
  }

  onSelectUser(user) {
    this.selectedUser = user;
  }

  assignToUser() {
    this.loadingAssign = true;
    this.handset ? this.assignHandsetToUser() : this.assignEquipmentToUser();
  }

  assignEquipmentToUser() {
    this.onLoadingAssign.emit(this.loadingAssign);
    this.equipmentService
      .assignToUser(
        this.equipment.pbx.id,
        this.selectedUser.pbxId,
        this.equipment.mac_address
      ).subscribe(
        (res:any) => {
          this.loadingAssign = false;
          this.onAssignToUser.emit(res);
          this.onLoadingAssign.emit(this.loadingAssign);
          this.notification.success(this.translate.instant(
            'equipment.details.modals.assigned-user.assign-success',
            {
              equipment: this.equipment.mac_address,
              firstName: this.selectedUser.firstName,
              lastName: this.selectedUser.lastName,
              extension: this.selectedUser.extension
            }
          ));
          this.close();
        }, () => {
          this.loadingAssign = false;
          this.onLoadingAssign.emit(this.loadingAssign);
          this.close();
        });
  }

  assignHandsetToUser() {
    this.onLoadingAssign.emit(this.loadingAssign);
    this.equipmentService.assignHandsetToUser(this.equipment.pbx.id, this.selectedUser.pbxId, this.equipment.mac_address, this.handset.ipui).subscribe((res) => {
      this.loadingAssign = false;
      this.onLoadingAssign.emit(this.loadingAssign);
      this.onAssignHandsetToUser.emit(res);
      this.notification.success(this.translate.instant(
        'equipment.details.modals.assigned-user.assign-handset-success',
        {
          handset: this.handset.ipui,
          firstName: this.selectedUser.firstName,
          lastName: this.selectedUser.lastName,
          extension: this.selectedUser.extension
        }
        ));
      this.close();
    }, () => {
      this.loadingAssign = false;
      this.onLoadingAssign.emit(this.loadingAssign);
      this.close();
    });
  }

  close() {
    this.activeModal.close();
  }

}
